export default __webpack_public_path__ + "static/media/Header.c9e22198.svg";